import React from 'react'
import * as Icons from 'assets/svgs'

export const ICONS_TYPES = Object.keys(Icons).map(_icon =>
  _icon.toLocaleLowerCase()
)

const getIcon = type =>
  Object.keys(Icons).find(_icon => _icon.toLocaleLowerCase() === type)

const Icon = ({
  size = 36,
  color = 'primaryColor',
  type,
  style = {},
  className = '',
  rotate = 90,
  id = '',
}) => {
  return (
    <span
      id={id}
      className={className}
      style={{ width: `${size}px`, height: `${size}px`, ...style }}
    >
      {React.createElement(Icons[getIcon(type)], { color, size, rotate })}
    </span>
  )
}

export default React.memo(Icon)
